/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { TagLangViewModelPaginatedResponse } from "../types/TagLangViewModelPaginatedResponse.ts";
import { tagLangViewModelSchema } from "./tagLangViewModelSchema.ts";

export const tagLangViewModelPaginatedResponseSchema = z.object({
  data: z.array(z.lazy(() => tagLangViewModelSchema)).nullish(),
  currentPage: z.optional(z.number().int()),
  totalPages: z.optional(z.number().int()),
  totalCount: z.optional(z.number().int()),
}) as unknown as ToZod<TagLangViewModelPaginatedResponse>;
